export default __webpack_public_path__ + "37fca04233514c34febc35910c8aecf8.svg";